import React from "react"
import PropTypes from "prop-types"

import RDatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

import { withTheme } from "emotion-theming"

import { css } from "react-emotion"

const DatePicker = props => {
    const styles = css`
        font-family: ${props.theme.fontFamily};
        font-size: ${props.theme.fontSize};
        background-color: ${props.theme.inputBackgroundColor};
        border-radius: ${props.theme.elementBorderRadius};
        padding: ${props.theme[props.padding || "small"]};
        border: ${props.theme.dividerThickness}px solid ${props.theme.outlineColor};

        &:focus {
            outline: none;
        }
    `

    return <RDatePicker {...props} className={styles} />
}

DatePicker.propTypes = {
    value: PropTypes.any,
    options: PropTypes.array,
    // { value: 'one', label: 'One' },
    //  { value: 'two', label: 'Two' },
    onChange: PropTypes.func,
}

export default withTheme(DatePicker)



// WEBPACK FOOTER //
// ./src/ui/components/DatePicker.js